/**
 * TrainerHomeRedirect — root '/' decides where to land.
 *
 *  Not authenticated → /login
 *  role=Formateur + external (Freelance) → /trainer (mobile-first space)
 *  role=Formateur + internal (Interne)   → /app (normal admin UI, filtered by role perms)
 *  Otherwise → /app (full admin layout)
 */
import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import api from '../../api/client';
import Logo from '../../components/Logo';

export default function TrainerHomeRedirect() {
  const { user, loading } = useAuth();
  const [trainerStatus, setTrainerStatus] = useState(undefined); // undefined = resolving

  useEffect(() => {
    if (!user) { setTrainerStatus(null); return; }
    const role = (user.role || '').toLowerCase();
    if (role !== 'formateur') { setTrainerStatus(null); return; }
    api.get('/me/trainer')
      .then(({ data }) => setTrainerStatus(data?.status || 'Freelance'))
      .catch(() => setTrainerStatus('Freelance')); // safest default = external
  }, [user]);

  if (loading || (user && (user.role || '').toLowerCase() === 'formateur' && trainerStatus === undefined)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <Logo size={48} variant="mark" />
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;

  const role = (user.role || '').toLowerCase();
  if (role === 'formateur' && trainerStatus === 'Freelance') return <Navigate to="/trainer" replace />;
  return <Navigate to="/app" replace />;
}

